import { Fragment, useCallback } from 'react'
import { ButtonPrimary, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import CustomError from '../../../../../../../../baseComponents/CustomError'
import LoadingSpinner from '../../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { ModalMediumCentered } from '../../../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import twinFetchPost from '../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import '../modalMoneyCashInOutTPVDSB.sass'

interface ModalConfirmMoneyCashInOutProps extends ModalConfirmMoneyCashInOutLogicProps {
}

const ModalConfirmMoneyCashInOut: React.FC<ModalConfirmMoneyCashInOutProps> = ({ ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept, loading } = useModalConfirmMoneyCashInOutLogic({ ...rest })
    const titleDict: TwinDictionary = {
        'cashIn': {
            title: t('sureWantToCashIn', '¿Estas seguro de que deseas realizar esta entrada de caja?'),
            subtitle: t('onceCompletedNotModifyRegister', 'Una vez realizado, no podrás modificar ese registro'),
            errorText: ''
        },
        'cashOut': {
            title: t('sureWantToCashOut', '¿Estas seguro de que deseas realizar esta salida de caja?'),
            subtitle: t('onceCompletedNotModifyRegister', 'Una vez realizado, no podrás modificar ese registro'),
            errorText: t('cashCountIsNegative', 'El recuento de caja es negativo')
        },
    }
    return (
        <ModalMediumCentered className='modal_cash_in_out_confirm flex_height' opened={true} setOpened={rest.setOpened} onClickOut={false}>
            <h2 className='my-20'>{titleDict[rest?.allRowData?.action].title}</h2>
            {rest.allRowData?.errors ? <CustomError textError={titleDict[rest.allRowData.action].errorText} className='mb-20' /> : null}
            <span>{titleDict[rest?.allRowData?.action].subtitle}</span>
            <div className='flex justify-center gap-x-33 mt-30 cash_in_out_confirm_buttons'>
                {loading ?
                    <LoadingSpinner /> :
                    <Fragment>
                        <ButtonSecondary onClick={() => rest.setOpened(null)}>
                            <TwinTrans transKey={'cancel'}>Cancelar</TwinTrans>
                        </ButtonSecondary>
                        <ButtonPrimary onClick={handleOnAccept} className={rest.allRowData?.errors ? 'button_red' : ''}>
                            {t('accept', 'Aceptar')}
                        </ButtonPrimary>
                    </Fragment>
                }
            </div>
        </ModalMediumCentered>
    )
}

interface ModalConfirmMoneyCashInOutLogicProps extends ModalEditComponentProps {
    allRowData: RowData
    url: string
}

const useModalConfirmMoneyCashInOutLogic = ({ allRowData, onSubmit, url }: ModalConfirmMoneyCashInOutLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const handleOnAccept = useCallback(async () => {
        startLoading?.()
        const result = await twinFetchPost(url, { ...allRowData })
        if (result) {
            endLoading?.()
        }
        onSubmit(result, {})
    }, [onSubmit, url, allRowData, startLoading, endLoading])
    return { handleOnAccept, loading }
}


export default ModalConfirmMoneyCashInOut